module.exports = __webpack_public_path__ + "static/HeaderVideo-6bb6dc90a895f2166e6a556d20a19d54.mp4";